export default {"src":"/_next/static/media/scholarship_page_background_dark.c8a9ca7f.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};